import { render } from "./SkeletonHome.vue?vue&type=template&id=a9811836&scoped=true"
import script from "./SkeletonHome.vue?vue&type=script&lang=js"
export * from "./SkeletonHome.vue?vue&type=script&lang=js"

import "@/assets/home.css?vue&type=style&index=0&id=a9811836&scoped=true&lang=css"
import "@/assets/slider.css?vue&type=style&index=1&id=a9811836&scoped=true&lang=css"
import "@/assets/gamesFeed.css?vue&type=style&index=2&id=a9811836&scoped=true&lang=css"
import "@/assets/skeletonHome.css?vue&type=style&index=3&id=a9811836&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a9811836"

export default script